<template>
  <div :class="['custom-ddl',dropdownMenuStyle, { 'bold-ddl': isBold, 'with-highlight': !sizeByContent, 'no-highlight': sizeByContent   }]">
    <label v-if="label" :class="[labelClass, { regular: regularLabel }]">
      {{ label }}
    </label>
    <div>
      <v-select
        :id="id"
        class="custom-v-select"
        :input-id="`${id}-input-search`"
        :class="{ 'was-Invalidated': error }"
        :label="fieldname"
        :options="listOptions"
        :value="value ? prefixText + valueText : prefixText"
        :disabled="isDisabled"
        :clearable="clearable"
        :placeholder="placeholder"
        :append-to-body="placementTop"
        :calculate-position="placementTop ? withPopper : () => {}"
        @input="updateValue"
      >
        <template>
          <input
            class="vs__search"
            :required="required"
            :value="value"
            @input="$emit('input', $event.target.value)"
          />
        </template>
      </v-select>
    </div>
    <Error v-if="error" variant="no-border" :message="customMsg" />
  </div>
</template>

<style scoped>
span.invalid:not(input) {
  color: #e85c5c;
}
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: gray;
  line-height: 19px;
}

.input-label.regular {
  font-weight: 400;
}
.custom-ddl div .v-select .vs__dropdown-toggle {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 2px solid #c5cdcf;
  opacity: 1;
  height: 38px;
}
.custom-ddl >>> .vs__dropdown-menu {
  min-width: 100% !important;
}

.custom-ddl.size-by-content >>> .vs__dropdown-menu {
  width: unset !important;
}
.custom-ddl .vs__dropdown-menu {
  background: #fff;
  border: none;
  position: relative;
}
.custom-ddl.with-highlight >>> .vs__dropdown-option--highlight {
  width: 220pc !important; /*Se coloca este valor porque por default acorta el hover si aparece scroll */
  display: block;
}
.custom-ddl.no-highlight >>> .vs__dropdown-option--highlight {
  display: block;
}
.custom-ddl :placeholder-shown,
.custom-ddl .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}
.custom-ddl span.vs__selected,
.custom-ddl .vs__selected-options .vs__selected,
.custom-ddl .vs__dropdown-menu .vs__dropdown-option {
  font-weight: 400 !important;
}
.custom-ddl .was-Invalidated {
  border-radius: 4px;
  border: 1px solid #ff0018;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}
.v-select.custom-v-select {
  background-color: white;
}
.v-select.custom-v-select.was-Invalidated {
  background-color: #f7d7da;
}
.custom-ddl >>> .v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 4px 4px;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}
</style>

<script>
import Error from '@/components/common/Error';
import { createPopper } from '@popperjs/core';
export default {
  name: 'CustomDropDown',
  meta: {
    description: 'Componente común DropDown personalizado.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  computed: {
    dropdownMenuStyle() {
      return {
        'size-by-content': this.sizeByContent,
      };
    },
    placement() {
      return 'top';
    },
    valueText() {
      let text = '';
      if (this.value) {
        if (this.value[this.fieldname]) text = this.value[this.fieldname];
        else if (
          this.value[this.fieldkey] != null &&
          this.value[this.fieldkey] != undefined &&
          this.options.length > 0
        ) {
          let option = this.options.find(
            (x) => x[this.fieldkey] == this.value[this.fieldkey]
          );
          if (option) text = option[this.fieldname];
        }
      }

      return text;
    },
    listOptions() {
      if (this.defaultValue && this.options.length > 0) {
        return [this.defaultValue, ...this.options];
      } else if (this.options.length == 0) {
        return [this.defaultValue]; //Return default value
      }

      return this.options;
    },
    isDisabled() {
      if (
        (this.disabled == null || this.disabled == false) &&
        this.value != null &&
        this.value.disabled
      ) {
        return this.value.disabled;
      }
      return this.disabled;
    },
  },
  props: {
    id: {
      type: String,
      default: () => '',
      meta: {
        description: 'Id del Componente CustomDropDown',
        example: 'IdCustomDropDown',
      },
    },
    options: {
      type: Array,
      default: function() {
        return [];
      },
      meta: {
        description: 'Posibilita elegir entre varias',
        example: '"[4, 8, 15, 16, 23, 42]',
      },
    },
    value: {
      type: Object,
      default: () => {},
      meta: {
        description: 'Parámetro de entrada del CustomDropDown',
        example: 'Texto requerido',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    labelClass: {
      type: String,
      default: 'input-label',
      meta: {
        description: 'Clases para el label',
        example: 'Texto requerido',
      },
    },
    prefixText: {
      type: String,
      default: '',
      meta: {
        description: 'Establece, texto de prefijo',
        example: 'Texto requerido',
      },
    },
    fieldkey: {
      type: String,
      meta: {
        description: 'Establece, clave de campo',
        example: 'id',
      },
      default: 'value',
    },
    fieldname: {
      type: String,
      meta: {
        description: 'Estable el nombre del campo',
        example: 'name',
      },
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia para el CustomDropDown',
        example: 'Seleccione',
      },
    },
    defaultValue: {
      type: Object,
      default: () => {},
      meta: {
        description:
          'Elemento que representa el valor NUll or Empty del CustomDropDown',
        example: '{ id: null,  name: "Todos", selected: "true" }',
      },
    },
    required: {
      type: String,
      default: function() {
        return '';
      },
      meta: {
        description: 'Estado requerido',
        example: 'Texto requerido',
      },
    },
    error: {
      type: [String, Boolean],
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      },
    },
    sizeByContent: {
      type: Boolean,
      required: false,
      default: () => true,
      meta: {
        description: 'Propiedad para determinar si el listado de opciones toma el tamaño segun contenido',
        example: 'true',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    onSelectionChange: {
      type: Function,
      default: function() {},
      meta: {
        description: 'Establece cambio de selección',
        example: '(value) => { return value.toUpperCase() }',
      },
    },
    clearable: {
      type: Boolean,
      default: () => true,
      meta: {
        description: 'Estado que limpia en el contenedor',
        example: 'True',
      },
    },
    regularLabel: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Control para mostrar texto en regular',
        example: 'true',
      },
    },
    placementTop: {
      type: Boolean,
      default: () => false,
      meta: {
        description: 'Establece posicionamiento superior.',
        example: 'true',
      },
    },
    isBold: {
      type: Boolean,
      required: false,
      default: () => false,
      meta: {
        description: 'Clases para el dropdown',
        example: 'true',
      },
    },
  },
  data() {
    return {
      customMsg: this.customErrorMsg,
    };
  },
  methods: {
    updateValue(value) {
      this.onSelectionChange();
      this.$emit('input', value);
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;
      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: this.placement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -1],
            },
          },
          {
            name: 'toggleClass',
            enabled: true,
            phase: 'write',
            fn({ state }) {
              component.$el.classList.toggle(
                'drop-up',
                state.placement === 'top'
              );
            },
          },
        ],
      });
      return () => popper.destroy();
    },
  },
  watch: {
    customErrorMsg(nw) {
      this.customMsg = nw;
    },
  },
};
</script>
